// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer_footer_2tNHb","logo":"footer_logo_26oVj","right":"footer_right_2onJW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footer.css
// module id = 348
// module chunks = 0